export default __webpack_public_path__ + "static/media/youtube.c4fe826d.svg";